"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Calendar;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Calendar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-5",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.464,38.543H24.536a2.5,2.5,0,0,0-2.5,2.5V51.972a2.5,2.5,0,0,0,2.5,2.5H35.464a2.5,2.5,0,0,0,2.5-2.5V41.043A2.5,2.5,0,0,0,35.464,38.543Zm-2.5,10.929H27.036V43.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.464,38.543H44.536a2.5,2.5,0,0,0-2.5,2.5V51.972a2.5,2.5,0,0,0,2.5,2.5H55.464a2.5,2.5,0,0,0,2.5-2.5V41.043A2.5,2.5,0,0,0,55.464,38.543Zm-2.5,10.929H47.036V43.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M64.536,38.543a2.5,2.5,0,0,0-2.5,2.5V51.972a2.5,2.5,0,0,0,2.5,2.5H75.464a2.5,2.5,0,0,0,2.5-2.5V41.043a2.5,2.5,0,0,0-2.5-2.5Zm8.428,10.929H67.036V43.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.464,58.543H24.536a2.5,2.5,0,0,0-2.5,2.5V71.972a2.5,2.5,0,0,0,2.5,2.5H35.464a2.5,2.5,0,0,0,2.5-2.5V61.043A2.5,2.5,0,0,0,35.464,58.543Zm-2.5,10.929H27.036V63.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M55.464,58.543H44.536a2.5,2.5,0,0,0-2.5,2.5V71.972a2.5,2.5,0,0,0,2.5,2.5H55.464a2.5,2.5,0,0,0,2.5-2.5V61.043A2.5,2.5,0,0,0,55.464,58.543Zm-2.5,10.929H47.036V63.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M75.464,58.543H64.536a2.5,2.5,0,0,0-2.5,2.5V71.972a2.5,2.5,0,0,0,2.5,2.5H75.464a2.5,2.5,0,0,0,2.5-2.5V61.043A2.5,2.5,0,0,0,75.464,58.543Zm-2.5,10.929H67.036V63.543h5.928Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,17.493H73V13.007a2.5,2.5,0,0,0-5,0v4.486H52.5V13.007a2.5,2.5,0,1,0-5,0v4.486H32V13.007a2.5,2.5,0,1,0-5,0v4.486H10a2.5,2.5,0,0,0-2.5,2.5v67a2.5,2.5,0,0,0,2.5,2.5H90a2.5,2.5,0,0,0,2.5-2.5v-67A2.5,2.5,0,0,0,90,17.493Zm-2.5,67h-75v-62H27v5.3a2.5,2.5,0,0,0,5,0v-5.3H47.5v5.3a2.5,2.5,0,0,0,5,0v-5.3H68v5.3a2.5,2.5,0,0,0,5,0v-5.3H87.5Z"
  })))));
}